"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var MetadataSimilarProductDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(MetadataSimilarProductDTO, _DomainObject_1$Domai);

  /**
   * DTO used for metadata report
   */
  function MetadataSimilarProductDTO(siteExternalId, siteName, predecessorActive, predecessorProductExternalId, predecessorProductName, successorActive, successorProductExternalId, successorProductName) {
    var _this;

    _classCallCheck(this, MetadataSimilarProductDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetadataSimilarProductDTO).call(this));
    _this.siteExternalId = siteExternalId;
    _this.siteName = siteName;
    _this.predecessorActive = predecessorActive;
    _this.predecessorProductExternalId = predecessorProductExternalId;
    _this.predecessorProductName = predecessorProductName;
    _this.successorActive = successorActive;
    _this.successorProductExternalId = successorProductExternalId;
    _this.successorProductName = successorProductName;
    return _this;
  }

  return MetadataSimilarProductDTO;
}(DomainObject_1.DomainObject);

exports.MetadataSimilarProductDTO = MetadataSimilarProductDTO;

MetadataSimilarProductDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(MetadataSimilarProductDTO.name);
  return {
    siteExternalId: builder.str('siteExternalId'),
    siteName: builder.str('siteName'),
    predecessorActive: builder.bool('predecessorActive'),
    predecessorProductExternalId: builder.str('predecessorProductExternalId'),
    predecessorProductName: builder.str('predecessorProductName'),
    successorActive: builder.bool('successorActive'),
    successorProductExternalId: builder.str('successorProductExternalId'),
    successorProductName: builder.str('successorProductName')
  };
}();